import { createElement, useContext, useEffect, useState } from 'react';
import { Field } from "rc-field-form";
import { ErrorMessageContext } from '../colorful-rcForm/colorful-rcForm';
import './index.scss';
const ColorfulRcItem = props => {
    const { name, label, labelWidth, required, pattern, error, children, ...otherProps } = props;
    const labelFixWidth = labelWidth ? `${labelWidth}px` : 'auto';
    const [fieldRules, setFieldRules] = useState([]);
    const _otherProps = otherProps || {};
    const errorInfos = useContext(ErrorMessageContext);
    let errorMessage;
    if (errorInfos) {
        errorMessage = errorInfos.errorMessage;
    }
    const itemRules = [];
    if (required) {
        itemRules.push({ required: true, message: "请输入！" });
    }
    if (pattern) {
        itemRules.push({ pattern, message: error });
    }
    useEffect(() => {
        const rules = [];
        if (required) {
            rules.push({
                required: true,
                message: '请输入',
            });
        }
        if (pattern) {
            rules.push({
                pattern,
                message: error,
            });
        }
        setFieldRules(rules);
    }, [required, pattern, error]);
    return (createElement("div", { className: "au-rc-form-item", key: name, ..._otherProps },
        createElement("label", { className: "au-rc-form-item-title", style: { width: labelFixWidth } },
            required && createElement("span", { className: "au-rc-title-require" }, "*"),
            label || '表单项'),
        createElement("div", { className: "au-rc-form-item-pane" },
            createElement(Field, { key: name, name: name, rules: fieldRules }, children),
            errorMessage && errorMessage[name] && createElement("div", { style: { color: 'red' } }, errorMessage[name]))));
};
ColorfulRcItem.displayName = 'ColorfulRcItem';
export default ColorfulRcItem;
